import { Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useT } from "src/i18n";

// Shared title row for the Tarkista step's sections. Renders the
// 'Black Ops One' label + an optional secondary-style action button
// on the right. The button is hidden when onEdit is not provided.
// The pencil icon makes the action read as interactive — without it the
// muted-text label was indistinguishable from the static field labels.
const headerButtonSx = {
    color: "text.secondary",
    textTransform: "none",
    letterSpacing: 0,
    fontWeight: 500,
    "&:hover": { backgroundColor: "transparent", color: "text.primary" },
    "& .MuiButton-startIcon": { marginRight: 0.5 },
};

const titleSx = {
    fontFamily: "'Black Ops One', serif",
    fontSize: 16,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "text.primary",
};

export default function SectionHeader({ title, badge, onEdit, editLabel }) {
    const t = useT();
    const resolvedEditLabel = editLabel ?? t("wizard.sectionHeader.defaultEditLabel");
    return (
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center", mb: 1.25 }}>
            <Stack direction="row" spacing={1.25} sx={{ alignItems: "center", flexWrap: "wrap", rowGap: 0.5 }}>
                <Box sx={titleSx}>{title}</Box>
                {badge}
            </Stack>
            {onEdit && (
                <Button
                    size="small"
                    onClick={onEdit}
                    startIcon={<EditIcon sx={{ fontSize: 15 }} />}
                    sx={headerButtonSx}
                >
                    {resolvedEditLabel}
                </Button>
            )}
        </Stack>
    );
}
